<div [formGroup]="form">
      <!-- New Payer-->
      <div class="form-group">
        <fc-new-item-button
          [baseId]="baseId"
          [findControlId]="FindControlIdService.ViewInsuranceCarrier"
          buttonTitle="+ New Payer"
          (itemSaveSucceed)="setInsurancePayer($event)"
        ></fc-new-item-button>
      </div>
      <!-- New Payer-->
  <div class="flex-row-generic">
    <!-- Payer Control -->
    <div class="form-group flex-item-three-columns">
      <label for="{{ baseId }}-payer-findcontrol">Payer</label>
      <ap-findcontrol
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('InsuranceCarrierUid')"
        [findControlId]="FindControlIdService.ViewInsuranceCarrier"
        [singleSelect]="true"
        [(selectedPks)]="selectedInsurancePayerPks"
        id="{{ baseId }}-payer-findcontrol"
        baseId="{{ baseId }}-payer-findcontrol"
        controlName="insuranceCarrierUid"
        findControlDisplayName="Find Payer"
        (chipsChange)="onInsurancePayerDataPopulate($event)"
        (dirty)="insuranceCarrierUidControl.markAsDirty()"
        (chipValueChanged)="insurancePayerChanged($event)"
      >
      </ap-findcontrol>
    </div>
    <!-- Payer Control -->

    <!-- Name Control -->
    <div class="form-group flex-item-three-columns">
      <label
        for="{{ baseId }}-name"
        translate
      >Name</label>
      <input
        id="{{ baseId }}-name"
        class="form-control"
        [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.Name.MaxLength"
        formControlName="name"
      />
      <div
        *ngIf="showErrors(nameControl, isSubmitted)"
        id="{{ baseId }}-warning-text-name"
        class="incorrect-input"
        translate
      >
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- External Id Control -->
    <div class="form-group flex-item-three-columns">
      <label
        for="{{ baseId }}-id"
        translate
      >ID</label>
      <input
        id="{{ baseId }}-id"
        class="form-control"
        [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
        formControlName="externalId"
      />
      <div
        *ngIf="showErrors(externalIdControl, isSubmitted)"
        id="{{ baseId }}-warning-text-id"
        class="incorrect-input"
        translate
      >
        {{ externalIdControl.errors | fcListValidation : 'ID' }}
      </div>
    </div>
    <!-- External Id Control -->
  </div>
  <div class="flex-row-generic">
    <!-- Use Payer's Address checkbox -->
    <div class="checkbox-group form-group flex-item-three-columns">
      <mat-checkbox
        id="{{ baseId }}-useCarrierAddress-checkbox"
        formControlName="useCarrierAddress"
        translate
      >
        Use Payer's Address </mat-checkbox>
    </div>
    <!-- Use Payer's Address checkbox -->
  </div>

  <hr />
  <h4
    id="{{ baseId }}-address-subtitle"
    translate
  >Address</h4>
  <!-- Address Group -->
  <fc-address-list
    [baseId]="baseId + 'address'"
    [form]="addressGroup"
    [listItem]="listItem.Address"
    [isSubmitted]="isSubmitted"
    [itemContext]="itemContext"
    (areaCode)="onSetAreaCode($event)"
    [disableControls]="disableAddressListControls"
  ></fc-address-list>
  <!-- Address Group -->

  <hr />
  <h4
    id="{{ baseId }}-contact-information-subtitle"
    translate
  >Contact Information</h4>
  <!-- Contact Information Group -->
  <fc-phone-number-list
    [baseId]="baseId"
    [form]="phoneOneGroup"
    [listItem]="listItem.Phone1"
    [isSubmitted]="isSubmitted"
    [itemContext]="itemContext"
    [index]="1"
  ></fc-phone-number-list>
  <fc-phone-number-list
    [baseId]="baseId"
    [form]="phoneTwoGroup"
    [listItem]="listItem.Phone2"
    [isSubmitted]="isSubmitted"
    [itemContext]="itemContext"
    [index]="2"
  ></fc-phone-number-list>
  <fc-phone-number-list
    [baseId]="baseId"
    [form]="phoneThreeGroup"
    [listItem]="listItem.Phone3"
    [isSubmitted]="isSubmitted"
    [itemContext]="itemContext"
    [index]="3"
  ></fc-phone-number-list>
  <fc-phone-number-list
    [baseId]="baseId"
    [form]="phoneFourGroup"
    [listItem]="listItem.Phone4"
    [isSubmitted]="isSubmitted"
    [itemContext]="itemContext"
    [index]="4"
  ></fc-phone-number-list>
  <!-- Contact Information Group -->

  <!-- Notes Control -->
  <div class="full-control form-group flex-item-three-columns">
    <label
      for="{{ baseId }}-notes"
      translate
    >Notes</label>
    <textarea
      class="form-control"
      [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
      id="{{ baseId }}-notes"
      [maxlength]="fcListValidation.validations.Notes.MaxLength"
      formControlName="notes"
      rows="3"
    >
              </textarea>
    <div
      *ngIf="showErrors(notesControl, isSubmitted)"
      id="{{ baseId }}-warning-text-notes"
      class="incorrect-input"
      translate
    >
      {{ notesControl.errors | fcListValidation : 'Notes' }}
    </div>
  </div>
  <!-- Notes Control -->

  <!-- Inactive checkbox -->
  <div class="checkbox-group">
    <mat-checkbox
      id="{{ baseId }}-inactive-checkbox"
      formControlName="inactive"
      translate
    > Inactive </mat-checkbox>
  </div>
  <!-- Inactive checkbox -->
